import { FONT } from "@/styles/common";
import { Table, Td } from "@chakra-ui/react";
import styled from "@emotion/styled";

export const CustomTable = styled(Table)`
    width: 100%;
    border-collapse: collapse;
    box-sizing: border-box;
    border-top: 1px solid ${({ theme }) => theme.COLOR.text[400]};

    & tr {
        height: 72px;
        box-sizing: border-box;

        @media (max-width: ${({ theme }) => theme.MEDIA.tablet}) {
            height: 36px;
        }
    }

    & tr:nth-of-type(2) td {
        color: ${({ theme }) => theme.COLOR.text[300]};
    }

    & th,
    td {
        white-space: nowrap;
        text-align: center;
        border-bottom: 1px solid ${({ theme }) => theme.COLOR.text[400]} !important;
        ${FONT("pretendard", 16, 500)}
    }

    & th {
        color: ${({ theme }) => theme.COLOR.black};
        background: ${({ theme }) => theme.COLOR.pagination[100]};

        letter-spacing: -1px;
    }
`;

interface CustomTdProps {
    isAvailableBook: boolean;
}

export const CustomTd = styled(Td)<CustomTdProps>`
    color: ${({ isAvailableBook }) =>
        isAvailableBook ? ({ theme }) => theme.COLOR.positive[100] : ({ theme }) => theme.COLOR.negative};
`;
